import axios from "~src/utils/axios";
import type { IItemString } from "~src/interfaces/commom";

const BASE_URL: IItemString = {
  // football: 'http://localhost:3003/v1/thesport',
  football: "https://v1.api-score.com",
  basketball: "https://bkb.sportflowlivez.com",
  tennis: "https://tn.sportflowlivez.com",
  badminton: "https://badminton.sportflowlivez.com",
  volleyball: "https://volleyball.sportflowlivez.com",
  // badminton: 'http://localhost:3002/v1/thesport',
  baseball: "https://baseball.sportflowlivez.com",
  // esports
  csgo: "https://esports.sportflowlivez.com",
  lol: "https://esports.sportflowlivez.com",
  dota2: "https://esports.sportflowlivez.com",
};

const getApiUrl = (sportType: string, path: string) => {
  return `${BASE_URL[sportType]}/${path}`;
};

const getApiUrlFootballBySiteName = (siteName: string, path: string) => {
  return `https://data.sportflowlivez.com/v1/${siteName}${path}`;
};

const getApiUrlFootballBySiteNameNew = (siteName: string, path: string) => {
  return `https://xl.api-score.com/${siteName}${path}`;
};

const getApiUrlSearchBySport = (query: string, sport: string = 'football', index: string = '') => {
  return `https://opt-search.api-score.com/api/v2/search/all/?sport=${sport}&page=1&q=${query}${index ? `&index=${index}` : ''}`;
};

export const countryAll = async (sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/country/all`);

  return await axios.get(url);
};

export const categoryAll = async (sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/category/all`);

  return await axios.get(url);
};

export const competitionAll = async (sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/competition/all`);

  return await axios.get(url);
};

export const competitionFeatured = async (sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/competition/featured`);

  return await axios.get(url);
};

export const matchSchedule = async (
  filterDate: string,
  sportType = "football"
) => {
  const url = getApiUrl(sportType, `${sportType}/match/schedule/${filterDate}`);

  return await axios.get(url);
};

export const scheduleBySeasonId = async (
  seasonId: string,
  sportType = "football"
) => {
  const url = getApiUrl(sportType, `${sportType}/schedule/${seasonId}/season`);

  return await axios.get(url);
};

export const competitionDetail = async (
  competitionId: string,
  sportType = "football"
) => {
  const url = getApiUrl(sportType, `${sportType}/competition/${competitionId}`);

  return await axios.get(url);
};

export const matchRecent = async (ymd: string, sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/match/recent/${ymd}`);

  return await axios.get(url);
};

export const matchHighlights = async (ymd: string, siteName = "xoilacz") => {
  const url = getApiUrlFootballBySiteName(siteName, `/highlight/date/${ymd}`);

  return await axios.get(url);
};

export const matchHighlightsByCompetitionId = async (competitionId: string, siteName = "xoilacz") => {
  const url = getApiUrlFootballBySiteName(siteName, `/highlight/competition/${competitionId}`);

  return await axios.get(url);
};

export const matchRecentInverse = async (
  ymd: string,
  sportType = "football"
) => {
  const url = getApiUrl(sportType, `${sportType}/match/recent/${ymd}/inverse`);

  return await axios.get(url);
};

export const matchDetailLive = async (sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/match/detail_live`);

  return await axios.get(url);
};

export const matchDetailLiveEsport = async (sportType = "lol") => {
  const url = getApiUrl(sportType, "esports/match/detail_live");

  return await axios.get(url);
};

export const matchDetail = async (matchId: any, sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}`);

  return await axios.get(url);
};

export const matchIncidents = async (matchId: any, sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/incidents`);

  return await axios.get(url);
};

export const matchStatistics = async (matchId: any, sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/statistics`);

  return await axios.get(url);
};

export const matchSquads = async (matchId: any, sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/squads`);

  return await axios.get(url);
};

export const matchIncidentsHome = async (
  sportType: string,
  matchId: string
) => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/incidents`);

  return await axios.get(url);
};

export const matchStatisticsHome = async (
  sportType: string,
  matchId: string
) => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/statistics`);

  return await axios.get(url);
};

export const matchLineups = async (matchId: any, sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/lineups`);

  return await axios.get(url);
};

export const seasonMatches = async (
  seasonId: string,
  sportType = "football"
) => {
  const url = getApiUrl(sportType, `${sportType}/season/${seasonId}/matches`);

  return await axios.get(url);
};

export const matchH2h = async (matchId: any, sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/h2h`);

  return await axios.get(url);
};

export const matchStanding = async (seasonId: any, sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/standing/${seasonId}`);

  return await axios.get(url);
};

export const mappingThesport = async (matchId: any, sportType = "football") => {
  const url = getApiUrl(sportType, `${sportType}/mapping/${matchId}/thesport`);

  return await axios.get(url);
};

export const shootingPointsMatch = async (
  matchId: any,
  sportType = "football"
) => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/shooting`);
  return await axios.get(url);
};

export const seasonBracketMatch = async (
  matchId: any,
  sportType = "football"
) => {
  const url = getApiUrl(sportType, `${sportType}/season/${matchId}/bracket`);
  return await axios.get(url);
};

export const getOddsMatch = async (sportType: any, matchId: any) => {
  const url = getApiUrl(sportType, `${sportType}/match/${matchId}/odd`);

  return await axios.get(url);
};

export const getRealtimeDetail = async (matchId: any, sportType: any) => {
  const url = getApiUrl(
    sportType,
    `${sportType}/match/${matchId}/realtime-detail`
  );
  return await axios.get(url);
};

export const getTeamOverview = async (teamID: any, sportType: any) => {
  const url = getApiUrl(
    sportType,
    `${sportType}/team/${teamID}/overview`
  );
  return await axios.get(url);
};

export const getTeamSalary = async (teamID: any, sportType: any) => {
  const url = getApiUrl(sportType, `${sportType}/team/${teamID}/salary`);
  return await axios.get(url);
};

export const getTeamSchedule = async (teamID: any, sportType: any) => {
  const url = getApiUrl(sportType, `${sportType}/team/${teamID}/schedule`);
  return await axios.get(url);
};
export const getTeamLineup = async (teamID: any, sportType: any) => {
  const url = getApiUrl(sportType, `${sportType}/team/${teamID}/lineup`);
  return await axios.get(url);
};
export const getTeamPlayerTransfer = async (teamID: any, sportType: any) => {
  const url = getApiUrl(
    sportType,
    `${sportType}/team/${teamID}/player-transfer`
  );
  return await axios.get(url);
};
export const getTeamHonor = async (teamID: any, sportType: any) => {
  const url = getApiUrl(sportType, `${sportType}/team/${teamID}/honor`);
  return await axios.get(url);
};

export const getTeamPlayerStats = async (teamID: any, sportType: any) => {
  const url = getApiUrl(sportType, `${sportType}/team/${teamID}/player-stats`);
  return await axios.get(url);
};

export const getPlayerStatistics = async (
  playerId: any,
  sportType: any
) => {
  const url = getApiUrl(
    sportType,
    `${sportType}/player/${playerId}/statistics`
  );
  return await axios.get(url);
};

export const getPlayerHistoryMatches = async (
  playerId: any,
  sportType: any
) => {
  const url = getApiUrl(
    sportType,
    `${sportType}/player/${playerId}/history-matches`
  );
  return await axios.get(url);
};

export const getPlayerHistorySeasons = async (
  playerId: any,
  sportType: any
) => {
  const url = getApiUrl(
    sportType,
    `${sportType}/player/${playerId}/history-seasons`
  );
  return await axios.get(url);
};

export const getPlayerCareer = async (
  playerId: any,
  sportType: any
) => {
  const url = getApiUrl(
    sportType,
    `${sportType}/player/${playerId}/career`
  );
  return await axios.get(url);
};

export const getPostList = async (siteName = "xoilacz") => {
  const url = getApiUrlFootballBySiteNameNew(siteName, `/v1/category/list`);

  return await axios.get(url);
};

export const getSearchResults = async (
  query: string,
  sportType = "football",
  index: string = ""
) => {
  const url = getApiUrlSearchBySport(query, sportType, index);

  return await axios.get(url);
};

export const getTopPlayers = async () => {
  return await axios.get("https://fb.sportliveapiz.com/football/top-players");
};

export const getTopScorePlayersBySeasonId = async (seasonId: string) => {
  return await axios.get(`https://fb.sportliveapiz.com/football/player/${seasonId}/top-scorer`);
};

export const getSuggestCompetitions = async () => {
  return await axios.get("https://opt-search.api-score.com/api/v2/search/suggest/competitions?lang=VI&sport=football");
};